export default "__VITE_ASSET__d2842074__"